<template>
  <main>
    <div class="tab-content">
      <div class="tab-pane active show">
        <!-- 資料呈現區塊 -->
        <div class="container" v-if="!editMode">
          <div class="row">
            <div class="col-12">
              <div class="radio radio-inline">
                <input type="radio" v-model="searchType" id="search-type-1" value="1" />
                <label for="search-type-1">已開放</label>
              </div>
              <div class="radio radio-inline">
                <input type="radio" v-model="searchType" id="search-type-2" value="2" />
                <label for="search-type-2">已刪除</label>
              </div>
              <hr />
              <table id="searchBlock">
                <thead>
                  <tr>
                    <td width="27%" class="text-center">
                      <select
                        :id="`start-date-year-${colKey}`"
                        :data-vv-name="`start-date-year-${colKey}`"
                        v-validate="'required'"
                        data-vv-as="查詢條件"
                        style="width: 100%"
                        class="form-control form-control-inline"
                        v-model="selectVal"
                        :class="{ 'is-invalid': errors.has(`start-date-year-${colKey}`) }"
                      >
                        <option value>請選擇</option>
                        <option
                          v-for="(item, index) in selectOption"
                          :key="`start-year-${index}`"
                          :value="Object.keys(item)[0]"
                        >
                          {{ item[Object.keys(item)[0]] }}
                        </option>
                      </select>
                    </td>
                    <td>
                      <input
                        type="text"
                        :id="`div-name-${colKey}`"
                        :data-vv-name="`div-name-${colKey}`"
                        v-validate="'required'"
                        data-vv-as="請輸入查詢條件"
                        class="form-control"
                        v-model="resVal"
                        alt="ch"
                        :class="{ 'is-invalid': errors.has(`div-name-${colKey}`) }"
                      />
                    </td>
                    <td>
                      <a class="btn btn-primary" @click="doQuery('resVal')">查詢</a>
                    </td>
                  </tr>
                </thead>
              </table>
              <hr />
              <table id="searchBlock">
                <thead>
                  <tr>
                    <th>開放日期</th>
                    <td width="30%" class="text-center">
                      <select
                        :id="`start-date-year-${colKey}`"
                        :data-vv-name="`start-date-year-${colKey}`"
                        v-validate="'required'"
                        data-vv-as="開放日期(起)"
                        class="form-control form-control-inline"
                        v-model="start_date[0]"
                        :class="{ 'is-invalid': errors.has(`start-date-year-${colKey}`) }"
                      >
                        <option value>年份</option>
                        <option v-for="(opt, y_opt_i) in yearOpt" :key="`start-year-${y_opt_i}`" :value="opt">
                          {{ opt - 1911 }}年
                        </option>
                      </select>

                      <span class="text">/</span>

                      <select
                        :id="`start-date-month-${colKey}`"
                        :data-vv-name="`start-date-month-${colKey}`"
                        v-validate="'required'"
                        data-vv-as="開放日期(起)"
                        class="form-control form-control-inline"
                        v-model="start_date[1]"
                        :class="{ 'is-invalid': errors.has(`start-date-month-${colKey}`) }"
                      >
                        <option value>月份</option>
                        <option v-for="(opt, m_opt_i) in monthOpt" :key="`start-month-${m_opt_i}`" :value="opt">
                          {{ opt }}月
                        </option>
                      </select>
                    </td>
                    <td>~</td>
                    <td width="30%" class="text-center">
                      <select
                        :id="`end-date-year-${colKey}`"
                        :data-vv-name="`end-date-year-${colKey}`"
                        v-validate="'required'"
                        data-vv-as="開放日期(訖)"
                        class="form-control form-control-inline"
                        v-model="end_date[0]"
                        :class="{ 'is-invalid': errors.has(`end-date-year-${colKey}`) }"
                      >
                        <option value>年份</option>
                        <option v-for="(opt, y_opt_i) in yearOpt" :key="`end-year-${y_opt_i}`" :value="opt">
                          {{ opt - 1911 }}年
                        </option>
                      </select>

                      <span class="text">/</span>

                      <select
                        :id="`end-date-month-${colKey}`"
                        :data-vv-name="`end-date-month-${colKey}`"
                        v-validate="'required'"
                        data-vv-as="開放日期(訖)"
                        class="form-control form-control-inline"
                        v-model="end_date[1]"
                        :class="{ 'is-invalid': errors.has(`end-date-month-${colKey}`) }"
                      >
                        <option value>月份</option>
                        <option v-for="(opt, m_opt_i) in monthOpt" :key="`end-month-${m_opt_i}`" :value="opt">
                          {{ opt }}月
                        </option>
                      </select>
                    </td>
                    <td>
                      <a class="btn btn-primary" @click="doQuery('')">查詢</a>
                    </td>
                  </tr>
                </thead>
              </table>

              <br />
              <table id="bullentin_datatable" class="table datatable table-striped area-list-datatable">
                <thead>
                  <tr>
                    <th>#</th>
                    <th
                      id="col_start_date"
                      :class="
                        'sorting ' +
                        (order.fieldName == 'CREATE_TIME' ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')
                      "
                      @click="processList('CREATE_TIME')"
                      class="text-center"
                    >
                      開放日期
                    </th>
                    <th
                      id="col_FORM_NO"
                      :class="
                        'sorting ' + (order.fieldName == 'FORM_NO' ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')
                      "
                      @click="processList('FORM_NO')"
                    >
                      簡覆表編號
                    </th>
                    <th
                      id="col_FMLYID"
                      :class="
                        'sorting ' + (order.fieldName == 'FMLYID' ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')
                      "
                      @click="processList('FMLYID')"
                    >
                      同仁ID
                    </th>
                    <th
                      id="col_EMP_NAME"
                      :class="
                        'sorting ' + (order.fieldName == 'EMP_NAME' ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')
                      "
                      @click="processList('EMP_NAME')"
                    >
                      同仁姓名
                    </th>
                    <th
                      id="col_DIV_SHORT_NAME"
                      :class="
                        'sorting ' +
                        (order.fieldName == 'DIV_SHORT_NAME' ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')
                      "
                      @click="processList('DIV_SHORT_NAME')"
                    >
                      同仁單位
                    </th>
                    <th
                      id="col_AGID"
                      :class="
                        'sorting ' + (order.fieldName == 'AGID' ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')
                      "
                      @click="processList('AGID')"
                    >
                      服務人員ID
                    </th>
                    <th
                      id="col_EMP_NAME_SERVE"
                      :class="
                        'sorting ' +
                        (order.fieldName == 'EMP_NAME_SERVE' ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')
                      "
                      @click="processList('EMP_NAME_SERVE')"
                    >
                      服務人員姓名
                    </th>
                    <th
                      id="col_DIV_SHORT_NAME_SERVE"
                      :class="
                        'sorting ' +
                        (order.fieldName == 'DIV_SHORT_NAME_SERVE' ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')
                      "
                      @click="processList('DIV_SHORT_NAME_SERVE')"
                    >
                      服務人員單位
                    </th>
                    <th
                      v-if="searchType === '1'"
                      id="col_EMP_NAME_SELECT"
                      :class="
                        'sorting ' +
                        (order.fieldName == 'EMP_NAME_SELECT' ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')
                      "
                      @click="processList('EMP_NAME_SELECT')"
                    >
                      輸入人員
                    </th>
                    <th
                      v-else
                      id="col_EMP_NAME_DELETE"
                      :class="
                        'sorting ' +
                        (order.fieldName == 'EMP_NAME_DELETE' ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')
                      "
                      @click="processList('EMP_NAME_DELETE')"
                    >
                      刪除人員
                    </th>
                    <th
                      id="col_MEMO"
                      :class="
                        'sorting ' +
                        (order.fieldName == 'MEMO' ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')
                      "
                      @click="processList('MEMO')"
                    >
                      備註
                    </th>
                    <th v-if="searchType === '1'" id="col_function" ref="lastCol" class="text-center">功能</th>
                    <th
                      v-else
                      id="col_DELETE_TIME"
                      :class="
                        'sorting ' +
                        (order.fieldName == 'DELETE_TIME' ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')
                      "
                      ref="lastCol"
                      @click="processList('DELETE_TIME')"
                    >
                      刪除日期
                    </th>
                  </tr>
                </thead>
                <!-- a005.create_time, a005.form_no,  a005.fmlyid, a005.memo, w002.emp_name,w002.div_short_name, a005.agid,  w001.emp_name_serve, w001.div_short_name_serve, w003.emp_name_SELECT -->
                <tbody id="bullentin-view" v-if="authorityList.length > 0">
                  <tr v-for="(item, index) in authorityList" :key="`td-authorityList-${index}-${item.ser_no}`">
                    <td>{{ index + 1 }}</td>
                    <td class="text-center">
                      <div class="date">{{ item.CREATE_TIME | dateFormat }}</div>
                    </td>
                    <td>{{ item.FORM_NO }}</td>
                    <td>{{ item.FMLYID |getMaskID}}</td>
                    <td>{{ item.EMP_NAME |getMaskName}}</td>
                    <td>{{ item.DIV_SHORT_NAME }}</td>
                    <td>{{ item.AGID |getMaskID}}</td>
                    <td>{{ item.EMP_NAME_SERVE |getMaskName}}</td>
                    <td>{{ item.DIV_SHORT_NAME_SERVE }}</td>
                    <td v-if="searchType === '1'">{{ item.EMP_NAME_SELECT |getMaskName}}</td>
                    <td v-else>{{ item.EMP_NAME_DELETE |getMaskName}}</td>
                    <td>{{ item.MEMO }}</td>
                    <td v-if="searchType === '1'" :width="iPadWidth" class="text-center">
                      <a class="text-green text-underline pointer-cursor" @click="doDelete(item)">刪除</a>
                    </td>
                    <td v-else>{{ item.DELETE_TIME | dateFormat }}</td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr>
                    <td colspan="12" class="empty">
                      <h3 class="text-center py-5">無任何資料</h3>
                    </td>
                    <td v-show="false"></td>
                    <td v-show="false"></td>
                    <td v-show="false"></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 打開遮罩 -->
    <mxMask :open="mxMaskOpen" />
  </main>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { commonMixin } from '@/mixins/common';
import { setTimeout } from 'timers';

//component
import TabHeaderBullentin from '@/desktop/components/backend/TabHeaderBullentin';
import BullentinContent from '@/desktop/views/backend/BullentinContent';
import mxMask from '@/desktop/components/mxMask';
//service
import { selectAGData, deleteAGFamily, selectAGDeleteData } from '@/service';
//parameter
const is_iPad = navigator.userAgent.match(/iPad/i) != null; // 確認裝置是否為 iPad

export default {
  name: 'BullentinView',
  mixins: [commonMixin],
  components: {
    TabHeaderBullentin,
    BullentinContent,
    mxMask,
  },
  data() {
    return {
      today: window.moment(),
      searchType: '1',
      mxMaskOpen: false,
      start_date: ['', ''],
      end_date: ['', ''],
      colKey: 'search',
      yearOpt: [],
      selectVal: '',
      selectOption: [
        { form_no: '簡覆表編號' },
        { fmlyid: '同仁ID' },
        { emp_name: '同仁姓名' },
        { div_short_name: '同仁單位' },
        { agid: '服務人員ID' },
        { emp_name_serve: '服務人員姓名' },
        { div_short_name_serve: '同仁單位' },
        { memo: '備註' },
      ],
      selectKey: '', //紀錄查詢
      resVal: '',
      monthOpt: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      authorityList: [], //顯示資料
      activeList: [], //已開放資料
      unActiveList: [], //已刪除資料
      order: {
        fieldName: 'subject',
        asc: true,
      },
      iPadWidth: 364,
      editData: {},
      editMode: false,
    };
  },
  watch: {
    searchType: function (val) {
      this.initColWidth();
      this.initDate('');
      this.init();
      if (val == '1') {
        this.authorityList = [...this.activeList];
        this.registerHanlink();
      } else {
        this.authorityList = [...this.unActiveList];
        this.registerHanlink();
      }
    },
  },
  computed: {
    ...mapGetters(['BaseUrl', 'UserInfo']),
  },
  methods: {
    ...mapActions(['setPageLock']),
    //欄位排序
    processList(fieldName) {
      let order = this.order;
      if (order.fieldName == fieldName) {
        order.asc = !order.asc;
      } else {
        order.fieldName = fieldName;
        order.asc = true;
      }

      //data排序
      let sortOrder = -1;
      if (order.asc) {
        sortOrder = 1;
      }

      switch (fieldName) {
        case 'CREATE_TIME':
          setTimeout(() => {
            this.authorityList.sort(this.dateCompareFun(sortOrder, fieldName));
            this.registerHanlink(); // 難字顯示
          }, 20);
          break;
        default:
          setTimeout(() => {
            this.authorityList.sort(this.sortCompareFun(sortOrder, fieldName));
            this.registerHanlink(); // 難字顯示
          }, 20);
      }
    },
    sortCompareFun(sortOrder, property) {
      return function (a, b) {
        const ar = a[property] ? a[property] : '';
        const br = b[property] ? b[property] : '';
        let result = ar < br ? -1 : ar > br ? 1 : 0;
        return result * sortOrder;
      };
    },
    //日期排序
    dateCompareFun(sortOrder, property) {
      return function (a, b) {
        let date_a = new Date(a[property] ? a[property] : '1880-01-01').getTime();
        let date_b = new Date(b[property] ? b[property] : '1880-01-01').getTime();
        let result = date_a < date_b ? -1 : 1;
        return result * sortOrder;
      };
    },
    //查詢
    doQuery(selectKey) {
      //檢核
      this.$validator.validateAll().then(el => {
        if (!el && selectKey) {
          let errMsg = [];
          for (let i = 0; i < this.errors.items.length; i++) {
            errMsg.push(this.errors.items[i].msg);
          }
          let showErrMsg = [...new Set(errMsg)];
          showErrMsg.forEach(s => {
            this.$toast.info({ title: s }); //印出檢核後的錯誤訊息
          });
          return;
        }
        let selectData;
        this.$validator.reset();
        if (!selectKey) {
          let startDate = ''; //查詢的起始日
          let endDate = ''; //查詢的結束日
          let lastDay = ''; //每月最後一天

          let startMonth =
            this.start_date[1].toString().length == 1
              ? '0' + this.start_date[1].toString()
              : this.start_date[1].toString();
          let endMonth =
            this.end_date[1].toString().length == 1 ? '0' + this.end_date[1].toString() : this.end_date[1].toString();

          let start = this.start_date[0] + startMonth;
          let end = this.end_date[0] + endMonth;
          if (parseInt(start) > parseInt(end)) {
            this.setToastMsg('發佈日期起始日不可大於結束日');
            return;
          }

          lastDay = new Date(this.end_date[0], parseInt(this.end_date[1]), 0).getDate();
          startDate = `${this.start_date[0]}-${startMonth}-01`;
          endDate = `${this.end_date[0]}-${endMonth}-${lastDay}`;

          selectData = {
            start_time: startDate,
            end_time: endDate,
          };
        } else {
          selectData = {
            [this.selectVal]: this.resVal,
          };
        }

        this.mxMaskOpen = true;
        this.selectKey = selectKey;
        if (this.searchType == '1') {
          selectAGData(this.UserInfo.id, selectData, '1', '').then(result => {
            this.mxMaskOpen = false;
            if (result.header && result.header.status == '200') {
              this.authorityList = result.body;
            } else {
              this.authorityList = [];
              this.setToastMsg(result.header.message);
            }
          });
        } else {
          selectAGDeleteData(this.UserInfo.id, selectData, '1', '').then(result => {
            this.mxMaskOpen = false;
            if (result.header && result.header.status == '200') {
              this.authorityList = result.body;
            } else {
              this.authorityList = [];
              this.setToastMsg(result.header.message);
            }
          });
        }
      });
    },
    //刪除資料
    doDelete(item) {
      const deleteData = {
        agid: item.AGID,
        form_no: item.FORM_NO,
        fmlyid: item.FMLYID,
        create_id: item.CREATE_ID,
        create_time: item.CREATE_TIME,
        agnm: item.EMP_NAME_SERVE,
        fmlynm: item.EMP_NAME,
        memo: item.MEMO,
        delete_id: this.UserInfo.id,
      };
      this.mxMaskOpen = true;
      deleteAGFamily(this.UserInfo.id, deleteData).then(result => {
        if (result.header && result.header.status == '200') {
          this.$toast.info({ title: '眷屬資料刪除成功' });
          this.initColWidth();
          this.doQuery(this.selectKey);
        } else {
          this.mxMaskOpen = false;
          this.$toast.info({ title: result.header.message });
        }
      });
    },
    doCancelEdit() {
      this.editMode = false;
    },
    //欄位寬度初始化
    initColWidth() {
      if (!is_iPad) {
        this.iPadWidth = this.$refs.lastCol.clientWidth - 15;
      } else {
        this.iPadWidth = this.$refs.lastCol.clientWidth;
      }
    },
    //查詢條件初始化
    initDate(startDateEdit) {
      let year = '';
      let month = '';
      if (startDateEdit) {
        year = startDateEdit.substring(0, 4);
        month = parseInt(startDateEdit.substring(5, 7));
      } else {
        year = this.today.year();
        month = this.today.month() + 1;
      }
      this.start_date[0] = year;
      this.start_date[1] = month;
      this.end_date[0] = year;
      this.end_date[1] = month;
    },
    //初始化 (若由新增畫面進入，觸發查詢)
    init() {
      let start = this.$route.params.start_date || '';
      if (start) {
        let start_Arr = start.split('-');
        this.start_date[0] = start_Arr[0]; //年
        this.end_date[0] = start_Arr[0]; //年
        if (parseInt(start_Arr[1]) > 9) {
          this.start_date[1] = start_Arr[1]; //月
          this.end_date[1] = start_Arr[1]; //月
        } else {
          this.start_date[1] = start_Arr[1].replace('0', ''); //月 (去除0)
          this.end_date[1] = start_Arr[1].replace('0', ''); //月 (去除0)
        }
      }
      setTimeout(() => {
        // this.doQuery('');
      }, 10);
    },
  },
  // beforeMount() {
  //   //檢查使用者是否為通路科/數支科的人
  //   if (this.$store.state.userInfo.divNo !== '9400400' && this.$store.state.userInfo.divNo !== '9N00200') {
  //     this.$router.push({ path: '/' });
  //   }
  // },
  mounted() {
    let start = window.moment().year();
    for (let s = start - 2; s <= start + 2; s++) {
      this.yearOpt.push(s);
    }
    this.initColWidth();
    this.initDate('');
    this.init();
  },
};
</script>

<style lang="scss" scoped>
.text-center {
  text-align: center;
}
.table.datatable {
  tbody {
    tr > td {
      &:first-child {
        padding-top: 10px;
      }
    }
  }
}
</style>
